const THEMES = {
    DARK: 'DARK',
    LIGHT: 'LIGHT'
}


export default THEMES